import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { ChainMaintenanceHandlingFeeModalComponent } from '../chain-maintenance-handling-fee-modal/chain-maintenance-handling-fee-modal.component';
import { HelperService, DialogService, AuthService, LanguageService } from 'src/app/services';
import { ConstantsHelper } from 'src/assets/constants/constants.helper';
import { ChainMaintenanceService } from '../chain-maintenance.service';
import { MatDialogRef } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { environment } from 'src/environments/environment';
import { of as observableOf, Subscription } from 'rxjs';
import { MediaObserver } from '@angular/flex-layout';
import { finalize, catchError } from 'rxjs/operators';
import * as _ from 'lodash';

@Component({
  selector: 'esc-chain-maintenance-detail',
  templateUrl: './chain-maintenance-detail.component.html',
  styleUrls: ['./chain-maintenance-detail.component.scss']
})
export class ChainMaintenanceDetailComponent implements OnInit {
  @Input() detail;
  @Input() detailKeys = [];
  @Input() loadError;
  @Input() type;
  @Input() disableEdit;
  @Input() disableEditMessage;
  @Input() moduleCode;
  @Input() displayMode;
  @Output() edit = new EventEmitter;
  @Output() closeDetail = new EventEmitter;
  @Output() downloadFile = new EventEmitter;

  constructor(
    public helper: HelperService,
    public media: MediaObserver,
    public authService: AuthService,
    private dialogService: DialogService,
    private languageService: LanguageService,
    private chainMntSvc: ChainMaintenanceService,
    ) { }

  private listSub: Subscription;
  private tableData: any;
  selectedTabIndex = 0;
  handling_fees = [
    {
      company: {
        id: 1,
        code: 'comp1',
        description: 'Company 1'
      },
      handling_fee: 99.99
    }
  ];

  loading = {
    handling_fee: false,
    error: false
  }
  public detailData;
  public constants = ConstantsHelper;
  displayedColumns: string[] = ['actions', 'company', 'handling_fee_value', 'is_active'];
  networkErrMsg = this.languageService.getTranslation("MSG_ERROR_NETWORK_CONNECTION", {});

  ngOnInit() {
    this.tableData = _.cloneDeep(INITIAL_OPTIONS);
    // console.log(this.moduleCode)
  }

  ngOnDestroy() {
    if (this.listSub && !this.listSub.closed) {
      this.listSub.unsubscribe();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    // console.log(changes.detail.currentValue)
    this.detailData = _.clone(changes.detail.currentValue);
    this.selectedTabIndex = 0;
  }

  tabChanged(tabChangeEvent: MatTabChangeEvent): void {
    this.selectedTabIndex = _.clone(tabChangeEvent.index);
    if(_.get(tabChangeEvent, 'index') == 1) {
      this.tableData.web_filter.chain_id = _.get(this.detailData, 'id');
      this.handling_fees = [];
      this.getHandlingFees();
    }
  }

  getHandlingFees() {
    let loadingDialog = this.dialogService.loading();
    this.loading.handling_fee = true;
    this.listSub = this.chainMntSvc.getHandlingFees(this.tableData).pipe(
      finalize(() => {
        loadingDialog.close();
        this.loading.handling_fee = false;
        return observableOf(null);
      }),
      catchError((err) => {
        if (this.handling_fees.length == 0) {
          this.loading.error = true;
        } else {
          this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_INTERNAL_SERVER_ERROR", {}));
        }
        return observableOf(null);
      }))
      .subscribe((res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }
        if (!res || res.status == 0 || res.status == 504 || res.status == 500) {

          this.dialogService.openSnackBar(this.networkErrMsg);
          return;
        }
        if (_.has(res, 'value') && (_.toLower(res.value) == _.toLower("Success"))) {
          this.handling_fees = this.handling_fees.concat(res.data);
        }
      });
  }

  close() {
    this.closeDetail.next(true);
  }

  modify() {
    if(this.disableEdit) {
      this.dialogService.openSnackBar(this.disableEditMessage);
      return;
    }
    this.edit.next(true);
  }

  download() {
    this.downloadFile.next(_.get(this, 'detailData'));
  }

  openHandlingFeeModal(data) {
    let dialogRef: MatDialogRef<ChainMaintenanceHandlingFeeModalComponent>;
    data["chain_id"] = _.get(this.detailData, 'id');
    
    dialogRef = this.dialogService.openDialog(ChainMaintenanceHandlingFeeModalComponent, {
      width: '40%',
      height: '40%',
      autoFocus: false,
      disableClose: true,
      data: data
    });
    dialogRef.afterClosed().subscribe((res) => {
      if(res) {
        this.selectedTabIndex = 0;
      }
    })
  }
}
 
const INITIAL_OPTIONS = {
	web_filter: {
    chain_id: 0,           
    limit: 50,
    offset: 0,
    keyword: "",
    is_asc: 1,
  }
};